// extracted by mini-css-extract-plugin
export default {"loaderSection":"loaderBrown_loaderSection__S9xaq","loaderSecitionh1":"loaderBrown_loaderSecitionh1__w-dk5","lds_ring":"loaderBrown_lds_ring__ihwSe"};